import React from 'react'
import GridLoadingSpinner from '../GridLoadingSpinner/GridLoadingSpinner'

const GridOverlayLoadingSpinner = () => (
    <div
    style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(255, 255, 255, 0.5)', // Semi-transparent white overlay
      display: 'flex' ,
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 9999, // Ensure the overlay appears on top
    }}
  >
    <div
      style={{
        margin: '40vh auto',
        height: '20vh',
        width: '20vh',
        textAlign: 'center',
        position: 'relative', // Ensure the loader is positioned relative to the overlay
      }}
    >
      <GridLoadingSpinner />
    </div>
  </div>
  )
export default GridOverlayLoadingSpinner